import React from 'react';

import { IconBasePropsWithColor } from './IconBase';

import { colors } from 'styles/cp';

const DocumentText: React.FC<IconBasePropsWithColor> = ({
  width = 24,
  height = 24,
  color = colors.gray02,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.49 9.44949C19.4851 9.37418 19.4699 9.29989 19.445 9.22866C19.4369 9.20207 19.4275 9.17592 19.4167 9.15033C19.3779 9.06391 19.3243 8.98494 19.2583 8.91699V8.91283L14.2583 3.91283C14.1894 3.84664 14.1097 3.7928 14.0225 3.75366C13.9967 3.74199 13.9692 3.73533 13.9392 3.72533C13.8695 3.70133 13.7969 3.68676 13.7233 3.68199C13.7017 3.67616 13.6858 3.66699 13.6667 3.66699H7C6.33696 3.66699 5.70107 3.93038 5.23223 4.39923C4.76339 4.86807 4.5 5.50395 4.5 6.16699V17.8337C4.5 18.4967 4.76339 19.1326 5.23223 19.6014C5.70107 20.0703 6.33696 20.3337 7 20.3337H17C17.663 20.3337 18.2989 20.0703 18.7678 19.6014C19.2366 19.1326 19.5 18.4967 19.5 17.8337V9.50033C19.5 9.48199 19.4908 9.46699 19.49 9.44949ZM14.5 6.51199L16.655 8.66699H15.3333C15.1123 8.66699 14.9004 8.57919 14.7441 8.42291C14.5878 8.26663 14.5 8.05467 14.5 7.83366V6.51199ZM17 18.667H7C6.77899 18.667 6.56702 18.5792 6.41074 18.4229C6.25446 18.2666 6.16667 18.0547 6.16667 17.8337V6.16699C6.16667 5.94598 6.25446 5.73402 6.41074 5.57774C6.56702 5.42146 6.77899 5.33366 7 5.33366H12.8333V7.83366C12.8333 8.4967 13.0967 9.13259 13.5656 9.60143C14.0344 10.0703 14.6703 10.3337 15.3333 10.3337H17.8333V17.8337C17.8333 18.0547 17.7455 18.2666 17.5893 18.4229C17.433 18.5792 17.221 18.667 17 18.667Z"
        fill={color}
      />
      <path
        d="M7.83333 10.3337H10.3333C10.5543 10.3337 10.7663 10.2459 10.9226 10.0896C11.0789 9.9333 11.1667 9.72134 11.1667 9.50033C11.1667 9.27931 11.0789 9.06735 10.9226 8.91107C10.7663 8.75479 10.5543 8.66699 10.3333 8.66699H7.83333C7.61232 8.66699 7.40036 8.75479 7.24408 8.91107C7.0878 9.06735 7 9.27931 7 9.50033C7 9.72134 7.0878 9.9333 7.24408 10.0896C7.40036 10.2459 7.61232 10.3337 7.83333 10.3337Z"
        fill={color}
      />
      <path
        d="M13.6667 12.8337H7.83333C7.61232 12.8337 7.40036 12.9215 7.24408 13.0777C7.0878 13.234 7 13.446 7 13.667C7 13.888 7.0878 14.1 7.24408 14.2562C7.40036 14.4125 7.61232 14.5003 7.83333 14.5003H13.6667C13.8877 14.5003 14.0996 14.4125 14.2559 14.2562C14.4122 14.1 14.5 13.888 14.5 13.667C14.5 13.446 14.4122 13.234 14.2559 13.0777C14.0996 12.9215 13.8877 12.8337 13.6667 12.8337Z"
        fill={color}
      />
      <path
        d="M13.6667 15.3337H7.83333C7.61232 15.3337 7.40036 15.4215 7.24408 15.5777C7.0878 15.734 7 15.946 7 16.167C7 16.388 7.0878 16.6 7.24408 16.7562C7.40036 16.9125 7.61232 17.0003 7.83333 17.0003H13.6667C13.8877 17.0003 14.0996 16.9125 14.2559 16.7562C14.4122 16.6 14.5 16.388 14.5 16.167C14.5 15.946 14.4122 15.734 14.2559 15.5777C14.0996 15.4215 13.8877 15.3337 13.6667 15.3337Z"
        fill={color}
      />
    </svg>
  );
};

export default DocumentText;
